<template>
    <div class="rightsCenter_ui">
        <div class="rightsCenter_box" :style="{ 'background': finalDatas.backgroundColor }">
            <!-- <div class="title" v-if="finalDatas.layout=='double'">
            权益商城
            <div class="more" @click="goRightsCenter()">
                更多
                <i class="iconfont icongengduo1"></i>
            </div>
        </div> -->
            <div class="coupon-list" :class="finalDatas.layout">
                <div class="item" v-for="(item, i) in coupons" :key="i" @click="showRightsInfo(item)"
                    v-if="i < finalDatas.maxnum">
                    <div class="coupon-logo">
                        <img :src="item.listPicture + '?imageView2/1/w/500/h/500/q80/format/webp'">
                        <div class="hotelName"><b>{{ item.hotelName }}</b></div>
                    </div>
                    <div class="coupon-info">
                        <div class="coupon-name">{{ item.name }}</div>
                        <div class="coupon-bottom">
                            <div class="coupon-points">
                                <div class="points" v-if="item.points"><img
                                        src="https://xcx.ihotel.cn/mall/images/money.png">{{ item.points }}</div>
                            </div>
                            <div class="coupon-btn" :class="{ 'disableBtn': item.disableBtn }">
                                {{ item.buttonText }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <!-- <div class="more" v-if="finalDatas.layout=='normal'">
            <div class="more_btn" @click="goRightsCenter()">点击查看更多<i class="iconfont icongengduo1"></i></div>
        </div> -->
        </div>
        <transition name="slide-fade">
            <div class="rightsCenter_layer" v-if="isRightsCenter">
                <div class="coupon-detail">
                    <div class="coupon-detail-box">
                        <div class="close" @click="isRightsCenter = false">
                            <i class="iconshanchu1 iconfont"></i>
                        </div>
                        <div class="coupon-logo">
                            <img :src="curCoupon.listPicture + '?imageView2/1/w/750/h/750/q80/format/webp'" alt="">
                            <div class="hotelName">{{ curCoupon.hotelName }}</div>
                            <div class="stock">库存 {{ curCoupon.stock }}</div>
                        </div>
                        <div class="coupon-info">
                            <div class="coupon-name">
                                {{ curCoupon.name }}
                            </div>
                            <div class="coupon-desc" v-html="curCoupon.detailPicture">

                            </div>
                        </div>
                    </div>
                    <div class="coupon-btn-box">
                        <div class="coupon-btn" @click="receiveSCCoupon">
                            <div class="points" v-if="curCoupon.points > 0"><img
                                    src="https://xcx.ihotel.cn/mall/images/money.png">{{ curCoupon.points }}</div>
                            <div class="btn">{{ curCoupon.buttonText }}</div>
                        </div>
                        <div class="goRight">
                            前往<b @click="goRight">权益中心</b>查看
                        </div>
                    </div>

                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    // 标题
    import api from "@/utils/api";
    import {
        jAlert3,jAlert6
    } from '@/base/jAlert/jAlert';
    import {
        getStorage
    } from '@/utils/wxuser';
    import {
        createUrl
    } from '@/utils/index';
    var config = {};
    export default {
        data() {
            return {
                finalDatas: {},
                isRightsCenter: false,
                user: getStorage('user'),
                wxuser: getStorage('wxuser'),
                coupons: [],
                curCoupon: {},
                crossGroupPointExchange: getStorage('crossGroupPointExchange'),
                exchangePoint: 0,
                creditName: getStorage('creditName') || '积分',
                currentCardIndex: 0,
                currentCard: {},
            };
        },
        props: ["datas","receivedList"],
       
        computed: {

        },
        destroyed() {
            this.resetBody()
        },
        watch: {
            receivedList(val){
                if(val&&val.length>0){
                    this.getCanReceived()
                }
               
            },
            isRightsCenter(val) {
                if (val) {
                    this.lockBody()
                } else {
                    this.resetBody()
                }
            }
        },
        created() {

            config = getStorage('config');
        },
        methods: {
            showRightsInfo(item) {
                if (item.disableBtn) {
                    return;
                }
                this.curCoupon = item
                this.isRightsCenter = true
            },
            queryCardPointBalanceWithUnionGroup(cb) {
               
                let opt = {
                    hotelGroupCode: config.hotelGroupCode,
                    channel: "wechat",
                    cardNo: this.currentCard.cardNo

                };
                
                api.queryCardPointBalanceWithUnionGroup(opt).then(res => {
                    if (res.result == 1) {
                        if (res.retVal.result == 0) {
                            this.exchangePoint = res.retVal.retVal
                        }
    
                        if (this.exchangePoint <= 0) {
                            this.crossGroupPointExchange = ''

                        }
                        
                        if (this.crossGroupPointExchange && this.exchangePoint > 0 && this.user.pointBalance < this.curCoupon.points) {
                            var lackPoint = this.curCoupon.points - this.user.pointBalance
                            var exchangePoint = 0
                            this.exchangePoint >= lackPoint ? exchangePoint = lackPoint : exchangePoint = this.exchangePoint
                            var url = window.location.href
                            jAlert6(`<div style="text-align: left;">兑换商品需要${this.curCoupon.points}${this.creditName}，您当前<br><div style="color: red;margin-top:10px;">可用${this.creditName}:${Math.floor(this.user.pointBalance)}${this.creditName}</div><div style="color: red;">可兑换${this.creditName}:${Math.floor(exchangePoint)}${this.creditName}</div><div style="margin-top:10px;">是否兑换${this.creditName}？</div></div>`, '去兑换', '取消', () => {
                                window.location.href = `/wechat/?/#/memberPointExchange?chargePoint=${exchangePoint}&redirect_url=${encodeURIComponent(url)}`
                            })
                            return;
                        }else{
                            cb&&cb()
                        }

                    } else {
                        jAlert3(res.msg)
                    }
                   

                })
            },
            receiveSCCouponFun() {
                var coupon = this.curCoupon
                var opt = {
                    cardId: this.user.cardId,
                    cardNo: this.user.cardNo,
                    couponCode: coupon.couponCode,
                    hotelGroupCode: config.hotelGroupCode,
                    hotelGroupId: config.hotelGroupId,
                    hotelCode: coupon.hotelCode,
                    memberId: this.user.memberId,
                    appid: config.appid,
                    openid: this.wxuser.openid,
                    couponType: coupon.couponType,
                    mobile: this.user.mobile,
                    shopCouponActivityId: coupon.id,
                    cardLevel: this.user.cardLevel || ""
                };
                opt.url = createUrl(opt)
                api.receiveSCCouponNew(opt).then((res) => {
                    if (res.result == 1) {
                        this.isRightsCenter = false
                        if (this.curCoupon.points > 0) {
                            this.user.pointBalance = this.user.pointBalance - this.curCoupon.points
                            jAlert3("兑换成功");
                           
                        } else {
                            jAlert3("领取成功");
                        }
                        this.getCanReceivedList()

                    } else {
                        jAlert3(res.msg);
                    }
                });
            },
            receiveSCCoupon() {

                if (this.isLogin()) {
                    [this.currentCard, this.currentCardIndex] = this.getCurrentCard();

                    var coupon = this.curCoupon
                    if (coupon.points > this.user.pointBalance&&this.crossGroupPointExchange) {
                        this.queryCardPointBalanceWithUnionGroup(()=>{
                            this.receiveSCCouponFun()
                          
                        })

                    } else {
                        this.receiveSCCouponFun()
                    }

                }
            },
            getCanReceived(){
                this.coupons = []
                this.finalDatas.items.forEach(item => {
                    this.receivedList.forEach((n, i) => {
                        if (item.id == n.id) {
                            if (n.points > 0) {
                                n.buttonText = '兑换';
                            } else {
                                n.buttonText = '领取';
                            }
                            if (n.canReceived !== 'T') {
                                n.disableBtn = true;
                                // if (n.points > 0) {
                                //     n.buttonText = '已兑换';
                                // } else {
                                //     n.buttonText = '已领取';
                                // }
                            }
                            this.coupons.push(n)
                        }
                    })

                });
            },
            getCanReceivedList() {

                api
                    .getCanReceivedList({
                        hotelGroupCode: config.hotelGroupCode,
                        hotelGroupId: config.hotelGroupId,
                        memberId: this.user.memberId || '',
                        hotelCode: config.hotelCode,
                        cardLevel: this.user.cardLevel || "",
                        couponCenterShow: 'R',
                        groupAll: 'T'
                    })
                    .then((res) => {
                        if (res.result == 1) {
                            this.coupons = []
                            this.finalDatas.items.forEach(item => {
                                res.retVal.forEach((n, i) => {
                                    if (item.id == n.id) {
                                        if (n.points > 0) {
                                            n.buttonText = '兑换';
                                        } else {
                                            n.buttonText = '领取';
                                        }
                                        if (n.canReceived !== 'T') {
                                            n.disableBtn = true;
                                            // if (n.points > 0) {
                                            //     n.buttonText = '已兑换';
                                            // } else {
                                            //     n.buttonText = '已领取';
                                            // }
                                        }
                                        this.coupons.push(n)
                                    }
                                })

                            });

                        }

                    });
            },
            goRight() {
                window.location.href = "/wechat/?/#/discountList?groupCode=RIGHT"
            },
            goRightsCenter() {
                sessionStorage.setItem("shopRights", JSON.stringify(this.datas));
                this.$router.push({
                    path: '/shopRights'
                })
            },
        },
        mounted() {
            this.refreshMemberInfo();
            this.finalDatas = JSON.parse(JSON.stringify(this.datas))
            
        },
    };
</script>

<style lang="less" scoped>
    @import url("~@/styles/base.less");
    @import url("~@/styles/mixin.less");

    .rightsCenter_ui {
        .rightsCenter_box {
            padding-bottom: 0.266667rem;
        }

        .coupon-list {
            line-height: 1.4;

            .item {
                background: #fff;
                border-radius: 6px;
                box-shadow: 0px 6px 12px 0px rgba(47, 79, 79, 0.08);
                width: 2.506667rem;
                margin: 0 0.133333rem;
                padding-bottom: 0.266667rem;
                position: relative;
                display: inline-block;
                box-sizing: border-box;

                .coupon-logo {
                    position: relative;

                    img {
                        height: 2.506667rem;
                        width: 2.506667rem;
                        border-radius: 6px;
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                    }
                }

                .coupon-info {
                    padding: 0 0.266667rem;
                }

                .coupon-name {
                    margin-top: 0.133333rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    white-space: normal;
                    overflow: hidden;

                }

                .coupon-bottom {

                    width: 100%;

                }

                .coupon-points {
                    margin-top: 0.133333rem;
                    height: 0.453333rem;

                    .points {
                        line-height: 0.453333rem;
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: @color-theme;

                        img {
                            width: 15px;
                            height: 15px;
                            margin-right: 0.133333rem;
                        }
                    }

                }

                .coupon-btn {
                    margin-top: 0.133333rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: @color-theme;
                    border-radius: 12px;
                    height: 0.64rem;
                    font-size: 12px;
                    color: #FFFFFF;

                    &.disableBtn {
                        background: #ddd;
                    }
                }

            }

            &.normal {
                white-space: nowrap;
                padding: 0.266667rem;
                overflow-x: scroll;
                overflow-y: hidden;

                .coupon-logo {
                    overflow: hidden;
                    height: 2.506667rem;
                    width: 2.506667rem;
                    border-radius: 6px;

                    .hotelName {

                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        left: 0;
                        right: 0;

                        b {
                            position: absolute;
                            bottom: 0;
                            text-align: center;
                            padding: 0 10px;
                            width: 100%;
                            height: 16px;
                            line-height: 16px;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                            box-sizing: border-box;
                            background: rgba(0, 0, 0, 0.50);
                        }
                    }
                }

                .coupon-bottom {
                    .coupon-btn {
                        width: 100%;
                    }
                }

            }

            &.double {
                display: flex;
                flex-wrap: wrap;
                padding: 0 0.266667rem 0.266667rem;

                .item {
                    margin-top: 0.266667rem;
                    width: 4.453333rem;

                    .coupon-name {
                        font-weight: bold;
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #333333;

                    }

                    .coupon-logo {
                        img {
                            width: 4.453333rem;
                            height: 4.453333rem;
                        }

                        .hotelName {
                            position: absolute;
                            bottom: 0;
                            left: 50%;
                            width: 86%;
                            margin-left: -43%;
                            height: 18px;
                            overflow: hidden;

                            b {
                                position: absolute;
                                text-align: center;
                                padding: 0 10px;
                                width: 100%;
                                height: 18px;
                                line-height: 18px;
                                z-index: 2;
                                font-size: 10px;
                                color: #fff;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                                white-space: normal;
                                overflow: hidden;
                                box-sizing: border-box;
                            }

                            &:after {
                                content: "";
                                position: absolute;
                                bottom: 0;
                                z-index: 1;
                                left: 50%;
                                margin-left: -41.5%;
                                width: 83%;
                                background: rgba(0, 0, 0, 0.50);
                                opacity: 0.6;
                                height: 18px;
                                box-sizing: border-box;
                                border-radius: 8px 8px 0 0;
                                transform: perspective(10px) scale(1.1, 1.3) rotateX(5deg);
                            }
                        }
                    }
                }

                .coupon-bottom {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .coupon-btn {
                        width: 1.493333rem;
                    }
                }

            }

        }

        .title {
            display: flex;
            justify-content: space-between;
            font-size: 22px;
            font-weight: bold;
            padding: 0.266667rem 0.4rem;

            .more {
                display: flex;
                height: 0.666667rem;
                align-items: center;
                background: #fff;
                padding: 0 0.133333rem 0 0.266667rem;
                border: 1px solid rgba(243, 113, 47, 0.1);
                border-radius: 14px;
                font-weight: normal;
                font-size: 12px;
                color: @color-theme;

                i {
                    font-size: 12px;

                }
            }
        }

        .more {
            display: flex;
            justify-content: center;

            .more_btn {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0.213333rem 0.533333rem;
                background: #FFFFFF;
                border: 1px solid #F2F2F2;
                border-radius: 0.426667rem;
                color: @color-theme;

                i {
                    color: @color-theme;
                    font-size: 10px;
                    margin-left: 0.133333rem;
                }
            }
        }

        .rightsCenter_layer {
            position: fixed;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 99;
            background: rgba(0, 0, 0, 0.50);

            .coupon-detail {
                width: 8.4rem;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background: #fff;
                border-radius: 6px;
                overflow: hidden;

                .coupon-detail-box {
                    overflow-y: scroll;
                }

                .close {

                    .iconfont {
                        position: absolute;
                        z-index: 2;
                        font-size: 24px;
                        top: 0.266667rem;
                        right: 0.266667rem;
                        color: rgba(255, 255, 255, 0.80);
                    }
                }

                .coupon-logo {
                    position: relative;
                    width: 100%;
                    height: 8.4rem;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                    .stock {
                        position: absolute;
                        bottom: 0.266667rem;
                        right: 0.266667rem;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 10px;
                        font-size: 10px;
                        color: #FFFFFF;
                        padding: 0.053333rem 0.266667rem;

                    }

                    .hotelName {
                        position: absolute;
                        top: 0.4rem;
                        left: 0.4rem;
                        background-image: linear-gradient(-45deg, #C4A06F 0%, #F3DBBF 100%);
                        border-radius: 4px;
                        font-family: PingFangSC-Medium;
                        font-size: 12px;
                        color: #62421B;
                        padding: 0.133333rem 0.213333rem;
                    }
                }

                .coupon-info {
                    padding: 0.4rem;

                    .coupon-name {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        white-space: normal;
                        overflow: hidden;
                        font-weight: bold;
                        font-family: PingFangSC-Semibold;
                        font-size: 20px;
                        color: #333333;
                        line-height: 1.4;
                    }

                    .coupon-desc {
                        margin-top: 0.4rem;
                        line-height: 20px;
                        font-size: 12px;
                        color: #666666;
                        max-height: 110px;

                    }
                }

                .coupon-btn-box {
                    border-top: 1px solid rgba(238, 238, 238, 1);
                    padding: 0.32rem 0;
                    background: #fff;
                    display: flex;
                    width: 100%;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;

                    .coupon-btn {
                        display: flex;
                        align-items: center;
                        border-radius: 20px;
                        height: 40px;
                        width: 200px;
                        background: @color-theme;
                        font-family: PingFangSC-Semibold;
                        font-size: 15px;
                        color: #FFFFFF;
                        line-height: 1.3;

                        .points {
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 15px;
                            flex: 1;

                            img {
                                width: 0.4rem;
                                height: 0.4rem;
                                margin-right: 0.16rem;
                            }

                            &::after {
                                content: '';
                                position: absolute;
                                right: 0;
                                height: 100%;
                                width: 1px;
                                top: 0;
                                background: #f1f1f1;
                            }
                        }

                        .btn {
                            display: flex;
                            justify-content: center;
                            font-size: 15px;
                            flex: 1;
                        }
                    }

                    .goRight {
                        margin-top: 10px;

                        b {
                            color: @color-theme;
                            font-weight: bold;

                        }
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/polymerization/rightsCenter.vue